import type { InterventionTemplateJsonEditorProps } from "./intervention-template-json-editor.type";

import AppSaveBar from "@/modules/app-save-bar";
import { JsonEditor } from "@/ui/json-editor";

import { useInterventionTemplateJsonEditor } from "./intervention-template-json-editor.hook";
import "./intervention-template-json-editor.style.less";

const InterventionTemplateJsonEditor = ({
  template,
}: InterventionTemplateJsonEditorProps) => {
  const {
    templates,
    isPending,
    isEditable,
    onSchemaChange,
    handleCancel,
    handleSave,
  } = useInterventionTemplateJsonEditor({ template });

  return (
    <>
      <div className="intervention-template-save-bar">
        <AppSaveBar
          onSave={handleSave}
          onCancel={handleCancel}
          loading={isPending}
          date={template.updated_at}
        />
      </div>
      <JsonEditor
        schema={[...templates]}
        onSchemaChange={onSchemaChange}
        isEditable={isEditable}
      />
    </>
  );
};

export default InterventionTemplateJsonEditor;
